import { render, staticRenderFns } from "./ChatContainer.vue?vue&type=template&id=d6beb442&scoped=true"
import script from "./ChatContainer.vue?vue&type=script&lang=js"
export * from "./ChatContainer.vue?vue&type=script&lang=js"
import style0 from "./ChatContainer.vue?vue&type=style&index=0&id=d6beb442&prod&lang=scss&scoped=true"
import style1 from "./ChatContainer.vue?vue&type=style&index=1&id=d6beb442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6beb442",
  null
  
)

export default component.exports